import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { FormsModule } from '@angular/forms';
import { TooltipLawComponent } from '../tooltip-law/tooltip-law.component';
import { TooltipInfoComponent } from '../tooltip-info/tooltip-info.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'field-type-password',
    templateUrl: './field-type-password.component.html',
    standalone: true,
    imports: [NgClass, TooltipInfoComponent, TooltipLawComponent, FormsModule, AfTranslateDirective]
})
export class FieldTypePasswordComponent implements OnInit, OnChanges {

  @Input() field : any ={};
  @Input() preSelectItem : any ='';
  @Output() itemSelected = new EventEmitter();

  fieldTypePassword:any = {
    symbolHide: '*',
    password: [],
  }
  isLanding: boolean = this.customLanding.isLanding();
  placeholder: any = '';
  constructor(
    private commonUtilsService: CommonUtilsService,
    private customLanding: CustomLandingFactory
    ) { }

  ngOnInit(): void {
    if(this.field) {
      this.fieldTypePassword.titleField = this.field.label;
        if(this.field.extendedLabel && this.field.extendedLabel !== ''){
          this.fieldTypePassword.titleField = this.field.extendedLabel;
        }
        this.field.id = this.field.generateId || !this.field.fieldId?this.commonUtilsService.createId() : this.field.fieldId;
    }
    this.configurePreselectValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['preSelectItem'] && this.preSelectItem !== this.fieldTypePassword.password.join("")){
      this.configurePreselectValue();
    }
  }

  inputHandle(e: any){
      if(!e.data && e.inputType=="deleteContentBackward"){
        if(e.target.value?.length){
          this.fieldTypePassword.password.pop();
        }else{
          this.fieldTypePassword.password = [];
        }
      }else if(!e.data && e.inputType=="insertFromPaste"){
        let pasteText: any = e.target.value.replaceAll("*", '');
        let actualText: any = this.fieldTypePassword.password.join("");
        this.fieldTypePassword.password = (actualText.substr(0, this.fieldTypePassword.selectionStart) + pasteText + actualText.substr(this.fieldTypePassword.selectionEnd)).split("");
      }else{
          this.fieldTypePassword.password.push(e.data);
      }
      delete this.fieldTypePassword.selectionStart;
      delete this.fieldTypePassword.selectionEnd;
      // e.target.value = this.field.visible?this.fieldTypePassword.password.join(""):this.fieldTypePassword.password.map(()=>this.fieldTypePassword.symbolHide).join("");
      if (this.field.visible) {
          e.target.value = this.fieldTypePassword.password.join("");
      } else {
        e.target.type = 'password';
      }
  }

  configurePreselectValue(){
    this.fieldTypePassword.password = this.preSelectItem?this.preSelectItem.split(""):[];
    setTimeout(()=>{
      this.configureInputValue();
    })
  }

  // changeVisible(){
  //   this.field.visible = !this.field.visible;
  //   this.configureInputValue();
  // }
  changeVisible() {
  this.field.visible = !this.field.visible;
  const input = document.getElementById('field-type-password-' + this.field.id) as HTMLInputElement;
  if (input) {
    input.type = this.field.visible ? 'text' : 'password';
  }
}

  configureInputValue(){
    let inputPassword: any = document.getElementById('field-type-password-'+this.field.id);
    inputPassword.value = this.field.visible?this.fieldTypePassword.password.join(""):this.fieldTypePassword.password.map(()=>this.fieldTypePassword.symbolHide).join("");
  }

  pasteTextInField(e:any){
    this.fieldTypePassword.selectionStart = e.target.selectionStart;
    this.fieldTypePassword.selectionEnd = e.target.selectionEnd;
  }

  changeInField(){
    this.itemSelected.emit({newValue:this.fieldTypePassword.password.join("")});
  }

  resetInput(){
    this.fieldTypePassword.password = [];
    this.configureInputValue();
    this.itemSelected.emit({newValue:''});
  }
}
